import BaseModel from './BaseModel';
import Review from './Review';

export default class AutoScreeningJob extends BaseModel {
  constructor(data = {}) {
    super(AutoScreeningJob, data);
    this.id = data.id;
    this.review = data.review ? new Review(data.review) : null;
    this.submittedAt = data.submittedAt;
    this.startedAt = data.startedAt;
    this.completedAt = data.completedAt;
    this.error = data.error;
    this.state = data.state;
    this.mode = data.mode;
  }
}
